module.exports = __webpack_public_path__ + "media/images/pc/stores/nara/nara_concept_01-f3a3d8c6a7915cd3d8fe247050f51ae7.jpg";